// extracted by mini-css-extract-plugin
module.exports = {"summary":"summary_summary__qbNVU"};